@if (data(); as msg) {
    {{msg.name}} <span>not found.</span>
}
 